export default function Machines_C_0 (number = 1) {
  return {
    name: '分拣器',
    icon: '/static/img/machines/c0.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_0.js